import React, {useEffect} from 'react';
import {useSelector} from "react-redux";
import {BrowserRouter, Route, Routes, useNavigate} from "react-router-dom";
import RequiredAuth from "./security/required-auth";
import SignIn from "./routes/signin/sign-in.route";
import Home from "./routes/home/home.route";
import MainLayout from "./components/layout/main-layout.component";
import SignOut from './routes/sign-out/sign-out.component';
import PostPage from "./routes/posts/posts.route";
import EventsPage from "./routes/events/events.route";
import SettingsPage from "./routes/settings/settings.route";
import NewsletterPage from "./routes/newsletter/newsletter.route";
import {getCurrentUser} from "./store/reducers/user/user.reducer";
import PostCreate from "./routes/posts/posts-create.route";
import PostEdit from "./routes/posts/posts-edit.route";
import EventCreate from "./routes/events/events-create.route";
import EventEdit from "./routes/events/events-update.route";
import MessagesPage from "./routes/messages/messages.route";

function App() {
    const currentUser = useSelector(getCurrentUser);

    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<RequiredAuth user={currentUser} />}>
                    <Route element={<MainLayout />}>
                        <Route index element={<Home />}/>
                        <Route path="posztok">
                            <Route index element={<PostPage />} />
                            <Route path={"letrehozas"} element={<PostCreate />} />
                            <Route path={"szerkesztes/:id"} element={<PostEdit />} />
                        </Route>
                        <Route path="uzenetek" element={<MessagesPage />}/>
                        <Route path="hirlevel" element={<NewsletterPage />}/>
                        <Route path="esemenyek">
                            <Route index element={<EventsPage />} />
                            <Route path={"letrehozas"} element={<EventCreate />} />
                            <Route path={"szerkesztes/:id"} element={<EventEdit />} />
                        </Route>
                        <Route path="beallitasok" element={<SettingsPage />}/>
                        <Route path="kijelentkezes" element={<SignOut />}/>
                    </Route>
                </Route>
                <Route path="/bejelentkezes" element={<SignIn />} />
                <Route path="*" element={<NavigateToHome/>}/>
            </Routes>
        </BrowserRouter>
    );
}

function NavigateToHome() {
    const navigate = useNavigate();

    useEffect(() => {
        navigate("/");
    }, []);

    return <div>...</div>;
}

export default App;
